// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__yYPAk","left":"Footer_left__104-L","right":"Footer_right__b5Ljy"};